export function userDisplayName(
  u: { first_name?: string | null; last_name?: string | null } | null | undefined,
): string {
  if (!u) return "";
  return [u.first_name, u.last_name].filter(Boolean).join(" ").trim();
}
